import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './Home.vue'
import Signin from './screens/Signin.vue'
import MyRoomsScreen from '@/screens/rooms/MyRoomsScreen.vue'
import CreateRoomScreen from '@/screens/rooms/CreateRoomScreen.vue'
import DiscountSettingsScreen from '@/screens/rooms/DiscountSettingsScreen.vue'
import MyPropertyScreen from './screens/properties/MyPropertiesScreen.vue'
import NewPropertyScreen from './screens/properties/NewPropertyScreen.vue'
import RentalsListScreen from '@/screens/rentals/RentalsListScreen.vue'
import RentalsCalendarScreen from '@/screens/rentals/RentalsCalendarScreen.vue'
import ChoresListScreen from '@/screens/chores/MyChoresScreen.vue'
import PublicChoresListScreen from '@/screens/chores/PublicChoresScreen.vue'
import ChoresCalendarScreen from '@/screens/chores/NewCalendarScreen.vue'
import ChoresNotificationsScreen from '@/screens/notifications/NotificationsListScreen.vue'
import NewNotificationScreen from '@/screens/notifications/NewNotificationScreen.vue'
import ContactsScreen from '@/screens/contacts/ContactsScreen.vue'
import HeatmapScreen from '@/screens/heatmap'
import ReportScreen from '@/screens/report'
import AIConversationsScreen from '@/screens/ai/AIConversationsScreen.vue'
import VoiceNoteChatScreen from '@/screens/ai/VoiceNoteChatScreen.vue'
import MobileCalendarParam from '@/components/mobile/MobileCalendarParam'
import NotFound from '@/screens/notfound/index.vue'

import { auth } from './Firebase'

import { logRouteEvent } from '@/functions/firebaseHelper.js'

Vue.use(VueRouter)

// const EmptyParent = {
//     render(createElement){
//         return createElement("router-view")
//     }
// }

const routes = [
  {
    path: '/',
    component: RentalsCalendarScreen,
    redirect: '/rentals/calendar',
    meta: { layout: 'new-layout', title: 'Rentalios | Calendar' }
  },
  {
    path: '/rentals/notfound',
    name: 'notfound',
    component: NotFound,
    meta: { layout: 'new-layout', title: 'Rentalios | Not Found' }
  },
  {
    path: '/mobilecal/:id',
    name: 'Mobile Calendar Param',
    component: MobileCalendarParam,
    meta: { layout: 'new-layout', title: 'Rentalios | Calendar' }
  },
  {
    path: '/signin',
    name: 'signin',
    component: Signin,
    meta: { layout: 'blank-layout', title: 'Rentalios | Sign in' }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Home'
    },
    redirect: '/rentals/calendar'
  },
  {
    path: '/rentals/calendar',
    name: 'rentals',
    component: RentalsCalendarScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Calendar'
    }
  },
  {
    path: '/rentals/list',
    name: 'rentalsList',
    component: RentalsListScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Rental List'
    }
  },
  {
    path: '/listings/properties',
    name: 'properties',
    component: MyPropertyScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Properties'
    }
  },
  {
    path: '/properties/new/:id?',
    name: 'editProperty',
    component: NewPropertyScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | New Property'
    }
  },
  {
    path: '/listings/rooms',
    name: 'rooms',
    component: MyRoomsScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Rooms'
    }
  },
  {
    path: '/rooms/new',
    name: 'NewRoom',
    component: CreateRoomScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | New Room'
    }
  },
  {
    path: '/rooms/edit/:roomId',
    name: 'EditRoom',
    component: CreateRoomScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Edit Room'
    }
  },
  {
    path: '/discount-settings',
    name: 'DiscountSettings',
    component: DiscountSettingsScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Discount Settings'
    }
  },
  {
    path: '/chores/calendar',
    name: 'ChoresCalendarScreen',
    component: ChoresCalendarScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Chores Calendar'
    }
  },
  {
    path: '/chores/list',
    name: 'ChoresListScreen',
    component: ChoresListScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Chores'
    }
  },
  {
    path: '/chores/publiclList',
    name: 'PublicChoresListScreen',
    component: PublicChoresListScreen,
    meta: {
      layout: 'header-only-layout',
      requiresAuth: false,
      title: 'Rentalios | Chores'
    }
  },
  {
    path: '/chores/notifications',
    name: 'ChoresNotificationsScreen',
    component: ChoresNotificationsScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Notifications'
    }
  },
  {
    path: '/chores/notifications/new',
    name: 'NewNotificationScreen',
    component: NewNotificationScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | New Notification'
    }
  },
  {
    path: '/contacts/housemates',
    name: 'ContactNewChoresCalendarScreenScreen',
    component: ContactsScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Housemates'
    }
  },
  {
    path: '/heatmap',
    name: 'heatmap',
    component: HeatmapScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Heatmap'
    }
  },
  {
    path: '/report',
    name: 'ReportScreen',
    component: ReportScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Report'
    }
  },
  {
    path: '/ai-agent',
    name: 'AIAgent',
    component: AIConversationsScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: true,
      title: 'Rentalios | Messages'
    }
  },
  {
    path: '/voice-note-chat',
    name: 'VoiceNoteChat',
    component: VoiceNoteChatScreen,
    meta: {
      layout: 'new-layout',
      requiresAuth: false,
      title: 'Rentalios | Voice note chat'
    }
  },
  {
    path: '*',
    beforeEnter: (to, from, next) => {
      next('/rentals/notfound')
    }
  },
  {
    path: '/rentals/notfound',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'Rentalios | Calendar' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Rentalios'
  const requiredAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiredAuth && !auth.currentUser) {
    next('/signin')
  } else if (to.name === 'signin' && auth.currentUser) {
    next('/')
  } else {
    logRouteEvent(to.fullPath)
    next()
  }
})

export default router
